var _rect, _rect2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholderEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 110,
    fill: "#FDF4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 180,
    height: 108,
    fill: "none",
    stroke: "#EF8E92",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 47,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "Replace with an image.")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 65,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "(Max: 364 x 220px)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholderEvent);
export default __webpack_public_path__ + "static/media/img-placeholder-event.01fdc8bd6d50d298d06050d798515a7d.svg";
export { ForwardRef as ReactComponent };